import React from "react";
import { VstDropdown } from "vstui";
var Isvg = require("../../../vendor/react-inlinesvg");
import { Button } from "@vitalsource/vstui";
import { createThemedComponent } from "@vitalsource/vstui/themes";
import { FilterKnobs } from "@vitalsource/vstui-icons";
import cloud from "@vitalsource/vstui/colors/cloud";

const ThemedButton = createThemedComponent(Button, {
  Button_paddingHorizontal_withIconMedium: "12px"
});

export default class FilterDropdown extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      menuOpen: ""
    };

    this.filterAll = this._filter.bind(this, "all");
    this.filterRead = this._filter.bind(this, "read");
    this.filterResources = this._filter.bind(this, "resources");
    this.filterAssignments = this._filter.bind(this, "assignments");
    this.filterRecentlyUpdated = this._filter.bind(this, "updated");

    this.showGrid = this._show.bind(this, "grid");
    this.showList = this._show.bind(this, "list");

    this.sortRecent = this._sort.bind(this, "recent");
    this.sortAZ = this._sort.bind(this, "az");
    this.sortZA = this._sort.bind(this, "za");
  }

  _filter(field) {
    this.props.changeFilter(field);
    Fraction.Reporter.gaEvent(`library/filter/${field}`);
  }

  _show(field) {
    this.props.onViewChange(field);
    Fraction.Reporter.gaEvent(`library/${field}`);
  }

  _sort(field) {
    this.props.changeSort(field);
    Fraction.Reporter.gaEvent(`library/sort/${field}`);
  }

  render() {
    const { view, filter, collection, sort } = this.props;
    return (
      <VstDropdown
        style={{ color: "white" }}
        headerTitle={i18n.t("base.filter")}
        headerBackButton={<Isvg src="img/arrow_white_left.svg" />}
        isMobile={Fraction.Helpers.isSmallScreen()}
        className="filter-dropdown"
        onOpen={() => this.setState({ menuOpen: true })}
        onClose={() => this.setState({ menuOpen: false })}
        target={
          <ThemedButton
            color={this.state.menuOpen ? "theme" : "neutral"}
            colorBehindButton={cloud.getShade(2)}
            iconStart={<FilterKnobs />}
            label={this.props.filterLabel}
            naked
            secondary
            tooltipPlacement="bottom-start"
          />
        }
      >
        <VstDropdown.Item role="subheader">
          {i18n.t("library.view")}
        </VstDropdown.Item>
        <VstDropdown.Item
          selected={view === "grid"}
          onClick={this.showGrid}
          closeOnClick={!Fraction.Helpers.isSmallScreen()}
        >
          {i18n.t("library.grid-view")}
        </VstDropdown.Item>
        <VstDropdown.Item
          selected={view === "list"}
          onClick={this.showList}
          closeOnClick={!Fraction.Helpers.isSmallScreen()}
        >
          {i18n.t("library.list-view")}
        </VstDropdown.Item>

        <VstDropdown.Item role="subheader">
          {i18n.t("filter.filter-by")}
        </VstDropdown.Item>
        <VstDropdown.Item
          selected={filter === "all"}
          onClick={this.filterAll}
          closeOnClick={!Fraction.Helpers.isSmallScreen()}
        >
          {collection
            ? i18n.t("filter.books-in-collection")
            : i18n.t("filter.all-books")}
        </VstDropdown.Item>
        <VstDropdown.Item
          selected={filter === "updated"}
          onClick={this.filterRecentlyUpdated}
          closeOnClick={!Fraction.Helpers.isSmallScreen()}
        >
          {i18n.t("filter.recently-updated")}
        </VstDropdown.Item>
        <VstDropdown.Item
          selected={filter === "read"}
          onClick={this.filterRead}
          visible={this.props.hasBooksRead}
          closeOnClick={!Fraction.Helpers.isSmallScreen()}
        >
          {i18n.t("filter.book-read")}
        </VstDropdown.Item>
        <VstDropdown.Item
          selected={filter === "resources"}
          onClick={this.filterResources}
          visible={Fraction.User.hasAncillaries}
          closeOnClick={!Fraction.Helpers.isSmallScreen()}
        >
          {i18n.t("filter.book-resources")}
        </VstDropdown.Item>
        <VstDropdown.Item
          selected={filter === "assignments"}
          onClick={this.filterAssignments}
          closeOnClick={!Fraction.Helpers.isSmallScreen()}
        >
          {i18n.t("filter.book-assignments")}
        </VstDropdown.Item>
        <VstDropdown.Item role="subheader">
          {i18n.t("sorting.sort-by")}
        </VstDropdown.Item>
        <VstDropdown.Item
          selected={sort === "recent"}
          onClick={this.sortRecent}
        >
          {i18n.t("sorting.recent-activity")}
        </VstDropdown.Item>
        <VstDropdown.Item
          selected={sort === "az"}
          onClick={this.sortAZ}
          closeOnClick={!Fraction.Helpers.isSmallScreen()}
        >
          {i18n.t("sorting.title-az")}
        </VstDropdown.Item>
        <VstDropdown.Item
          selected={sort === "za"}
          onClick={this.sortZA}
          closeOnClick={!Fraction.Helpers.isSmallScreen()}
        >
          {i18n.t("sorting.title-za")}
        </VstDropdown.Item>
      </VstDropdown>
    );
  }
}
